<wiz-hgroup #paramGP [wizDisabled]="!enabled" width="100%" height="100%" verticalAlign="center" style="padding: 5px">
  <wiz-label width="200px" [wizLabel]="data.label"></wiz-label>
  <wiz-checkbox
    #cbx
    [visible]="false"
    [wizTriStateMode]="false"
    [wizShowLabel]="false"
    [wizChecked]="false"
  ></wiz-checkbox>
  <wiz-text-input #ti [visible]="false" [wizShowLabel]="false" [wizMaxChars]="30"></wiz-text-input>
  <wiz-dropdown #dd [visible]="false" [wizMandatory]="true" [wizShowLabel]="false"></wiz-dropdown>
  <wiz-numeric-input #ni [visible]="false" wizShowLabel="false"></wiz-numeric-input>
  
  <wiz-hgroup #colorpick [visible]="false" width="100%" height="100%">
      <span
        #cellBlockBack
        [style.backgroundColor]="currentValue"
        width="20px"
        height="20px"
        (click)="showColorPicker($event)"
        style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
      ></span>
      <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('cellBlockBack')">removal</wiz-icon>
  </wiz-hgroup>


</wiz-hgroup>
